<div class="container">
  <section>
    <h1>401</h1>
    <h5 class="card-title font-weight-bold">UNAUTHORIZED</h5>
    <p class="card-text">Vous n'avez pas l'autorisation d'accéder à cette page...</p>
    <button class="btn btn-primary" (click)="logout()">Se déconnecter</button>
  </section>
</div>
